import { render, staticRenderFns } from "./statisticItem.vue?vue&type=template&id=be63a318&scoped=true&"
import script from "./statisticItem.vue?vue&type=script&lang=js&"
export * from "./statisticItem.vue?vue&type=script&lang=js&"
import style0 from "./statisticItem.vue?vue&type=style&index=0&id=be63a318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be63a318",
  null
  
)

export default component.exports